// i18n
import translations from 'presentations/views/components/pages/products/IntegrationPage/i18n.json';
import { translate, translateInComponent } from 'infras/i18n';
import { useContext } from 'react';
import { GetStaticPropsContext } from 'next';
import MainDocument from 'presentations/views/components/MainDocument';
import IntegrationPage from 'presentations/views/components/pages/products/IntegrationPage';
import { productIntegrationPath, webPath } from 'presentations/routes/path';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import { IntegrationType } from 'domains/models/account/providerType';

interface ServerProps {
  linkCanonical: string;
  id: IntegrationType;
}

export async function getStaticPaths({ locales }: { locales: string[] }) {
  const paths: Object[] = [];
  const ids = [IntegrationType.HubSpot, IntegrationType.Zoom];
  for (const locale of locales) {
    for (const id of ids) {
      paths.push({
        params: { id: String(id) },
        locale,
      });
    }
  }
  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({
  locale,
  params,
}: GetStaticPropsContext) {
  const id = Number(params!.id);
  const props: ServerProps = {
    id,
    linkCanonical: webPath(productIntegrationPath(id), locale),
  };
  return { props };
}

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;
  const serviceName = translate(`IntegrationType_${props.id}`);

  return (
    <MainDocument
      title={t('title', { serviceName })}
      description={t(`description ${props.id}`)}
      linkCanonical={props.linkCanonical}
    >
      <IntegrationPage viewer={viewer} id={props.id} />
    </MainDocument>
  );
}
